/**
 * @generated SignedSource<<a0a9611608bd637c619614555d1b3c3b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksMutation$variables = {
  tool: number;
};
export type hooksMutation$data = {
  readonly setSellerLastUsedTool: {
    readonly lastUsedTool: number | null;
  };
};
export type hooksMutation = {
  response: hooksMutation$data;
  variables: hooksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tool"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "tool",
    "variableName": "tool"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastUsedTool",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SellerSetting",
        "kind": "LinkedField",
        "name": "setSellerLastUsedTool",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "hooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SellerSetting",
        "kind": "LinkedField",
        "name": "setSellerLastUsedTool",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c6239abcd12c822c232d1d339b425d7",
    "id": null,
    "metadata": {},
    "name": "hooksMutation",
    "operationKind": "mutation",
    "text": "mutation hooksMutation(\n  $tool: Int!\n) {\n  setSellerLastUsedTool(tool: $tool) {\n    lastUsedTool\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "80fa825d9e58038883b4b96d899b5357";

export default node;
